import { getOverlayAlpha, Theme } from '@mui/material';

export function createScrollbarStyling(theme: Theme) {
  return {
    scrollbarWidth: 'thin',
    scrollbarColor: `${
      theme.palette.mode === 'light'
        ? `rgba(0, 0, 0, ${getOverlayAlpha(8)})`
        : `rgba(255, 255, 255, ${getOverlayAlpha(8)})`
    } transparent`,
  } as const;
}
